import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { formatApiError } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim() });
      setSent(true);
      toast.success("Si un compte existe, un e-mail de réinitialisation vient d'être envoyé.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cs-cream min-h-[80vh] py-16" data-testid="page-forgot-password">
      <div className="max-w-md mx-auto px-6">
        <div className="cs-eyebrow text-neutral-500">Espace client</div>
        <h1 className="cs-h1 mt-3 text-5xl">Mot de passe oublié.</h1>
        <p className="mt-4 text-sm text-neutral-600 leading-relaxed">
          Indiquez l'adresse e-mail associée à votre compte. Vous recevrez un lien
          sécurisé, valable 1 heure, pour choisir un nouveau mot de passe.
        </p>

        {sent ? (
          <div
            className="mt-10 p-6 border border-[#0E7C90]/30 bg-white/60"
            data-testid="forgot-password-sent"
          >
            <div className="cs-eyebrow text-[#0E7C90]">E-mail envoyé</div>
            <p className="mt-3 text-sm leading-relaxed text-neutral-700">
              Si un compte existe pour <strong>{email}</strong>, un message avec le lien
              de réinitialisation vient d'être envoyé. Pensez à vérifier votre dossier
              « courrier indésirable » si vous ne le voyez pas rapidement.
            </p>
            <div className="mt-6 flex items-center gap-4 text-sm">
              <Link
                to="/connexion"
                className="cs-link-underline text-[#0E7C90]"
                data-testid="forgot-password-back-to-login"
              >
                Retour à la connexion
              </Link>
              <button
                type="button"
                onClick={() => setSent(false)}
                className="cs-link-underline text-neutral-500"
                data-testid="forgot-password-resend"
              >
                Renvoyer avec une autre adresse
              </button>
            </div>
          </div>
        ) : (
          <form className="mt-10 space-y-5" onSubmit={submit}>
            <div>
              <label
                htmlFor="forgot-email"
                className="cs-eyebrow text-neutral-500"
              >
                Email
              </label>
              <input
                id="forgot-email"
                name="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="cs-input mt-2"
                data-testid="forgot-password-email-input"
                autoComplete="email"
              />
            </div>
            <button
              type="submit"
              disabled={loading || !email.trim()}
              className="cs-btn-primary w-full justify-center"
              data-testid="forgot-password-submit-button"
            >
              {loading ? "Envoi…" : "Envoyer le lien"}
            </button>
            <p className="text-sm text-neutral-600 pt-3">
              <Link
                to="/connexion"
                className="cs-link-underline text-[#0E7C90]"
                data-testid="forgot-password-back-link"
              >
                ← Retour à la connexion
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
